const setHeader = () => {
    
  const userToken = localStorage.getItem("token");
  const token = userToken ? JSON.parse(userToken).token : "";
  return {
    headers: {
      Authorization: `${token}`,
    },
  };
};
export default setHeader;